import { connect, mapProps, mapReadPretty } from '@formily/vue'
import { UploadPreviewCard } from '../PreviewText'
import { transformComponent } from '../../__builtins__/shared'
import UploadWrCom from './UploadWrapper'
import './style.scss'

const UploadWrapper = transformComponent(
  UploadWrCom,
  {
    // change: 'input'
  }
)

const Upload = connect(
  UploadWrapper,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(UploadPreviewCard)
)

export default Upload
